module.exports = __webpack_public_path__ + "img/Instrument.bf2b953d.svg";